export interface WorkSite {
  id:string; name:string; address_line:string|null; suburb:string|null; state:string|null; postcode:string|null;
  lat:number|null; lng:number|null; access_notes:string|null; induction_required:boolean; swms_required:boolean;
  cached?:boolean;
}

export function workLocationLinks(site:WorkSite) {
  const address=[site.address_line,site.suburb,site.state,site.postcode].filter(Boolean).join(", ");
  const hasPin=site.lat!==null && site.lng!==null && Number.isFinite(site.lat) && Number.isFinite(site.lng) && Math.abs(site.lat)<=90 && Math.abs(site.lng)<=180;
  // A state alone is not a useful work destination.
  const destination=hasPin ? `${site.lat},${site.lng}` : site.address_line ? `${address}, Australia` : null;
  return {
    address, hasPin,
    map: hasPin ? `https://www.openstreetmap.org/?mlat=${site.lat}&mlon=${site.lng}#map=18/${site.lat}/${site.lng}`
      : destination ? `https://www.openstreetmap.org/search?${new URLSearchParams({query:destination})}` : null,
    directions:destination ? `https://www.google.com/maps/dir/?${new URLSearchParams({api:"1",destination,travelmode:"driving"})}` : null,
  };
}
